import React from 'react';
import type { IconProps } from './icons.types';

export const CloseIcon: React.FC<IconProps> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 10 10" fill="currentColor" aria-hidden="true">
    <path d="M1.0635 9.648L0 8.5845L3.773 4.8115L0 1.0635L1.0635 0L4.8365 3.773L8.5845 0L9.648 1.0635L5.875 4.8115L9.648 8.5845L8.5845 9.648L4.8365 5.875L1.0635 9.648Z" />
  </svg>
);
